<template>
  <div class="pa-simple-message-attached-images">
    <ul class="items">
      <li v-for="(url, imageIndex) in images" :key="imageIndex">
        <!-- <img :src="url | mutateImageSizeTo250" @click.prevent="handleClickImage(imageIndex)" /> -->

        <picture>
          <source :srcset="url | mutateImageSizeTo250 | mutatePathPngToWebp" type="image/webp">
          <img class="thumbnail" :src="url | mutateImageSizeTo250" @click.prevent="handleClickImage(imageIndex)" />
        </picture>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props : {
    images : {
      default : []
    }
  },

  methods : {
    generatePhotoSwipeList(){
      const imageList = [];

      const isWebpSupported = this.isSupportWebp();

      for(let image of this.images){
        if(isWebpSupported){
          image = image.replace('.png', '.webp');
        }

        imageList.push({
          src : image,
          w   : 0,
          h   : 0,
        });
      }

      return imageList;
    },

    handleClickImage(imageIndex){
      this.$store.dispatch({
        type        : 'photoSwipe/updateImages',
        images      : this.generatePhotoSwipeList(),
        imageIndex  : imageIndex,
      });
    },

    isSupportWebp(){
      const elem = document.createElement('canvas');

      if( elem.getContext && elem.getContext('2d') ) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="scss">
.pa-simple-message-attached-images{
  border-top:1px solid #BFA07C;

  margin:.3rem .5rem .4rem;
  padding-top:.6rem;

  ul.items{
    display:flex;
    flex-direction: row;
    justify-content: space-between;

    li{
      width:48%;
      border-radius: 4px;
      position: relative;

      img.thumbnail{
        width:100%;
        vertical-align: middle;
        border-radius: 4px;
      }
    }
  }
}
</style>